import { debounce, validateAndConvertToLowerCase } from "./utils";
import { appState } from "./state";
import { fetchCurrentMovies, searchMovieByQuery } from "./MovieSearch";
import { renderMovies } from "./movieRenderer";

let isInitialized = false;

export const setUpEventListenersAndObserver = () => {
  if (isInitialized) return;
  isInitialized = true;

  const searchField = document.getElementById(
    "movieSearch",
  ) as HTMLInputElement | null;

  if (!searchField) return;

  const handleSearchInput = async (searchQuery: string) => {
    appState.resetPage("default");
    appState.resetPage("search");

    appState.setSearchString(searchQuery);
    const searchString = appState.getSearchString();

    appState.setViewingSearchResults(true);

    await searchMovieByQuery(searchString).then((movies) => {
      appState.clearMovies();
      appState.addToMovies(movies.results);
      renderMovies(movies.results, true);
    });
  };

  const debouncedHandleSearch = debounce(handleSearchInput, 400);

  searchField.addEventListener("input", async (e) => {
    const input = e.currentTarget as HTMLInputElement;
    const searchQuery = validateAndConvertToLowerCase(input?.value);
    if (!searchQuery) {
      appState.setViewingSearchResults(false);

      await fetchCurrentMovies().then((data) => {
        appState.clearMovies();
        appState.addToMovies(data.results);
        renderMovies(data.results, true);
      });

      return;
    }
    debouncedHandleSearch(searchQuery);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          if (!appState.getCurrentlyViewingSearchResults()) {
            await fetchCurrentMovies().then((data) => {
              appState.addToMovies(data.results);
              renderMovies(data.results, false);
            });
            appState.incrementPage("default");
          } else {
            const queryString = appState.getSearchString();
            await searchMovieByQuery(queryString).then((movies) => {
              appState.addToMovies(movies.results);
              renderMovies(movies.results, false);
            });
            appState.incrementPage("search");
          }
        }
      });
    },
    {
      rootMargin: "100px 50px",
      // scrollMargin: "100px",
      threshold: 0,
    },
  );
  const lastElementOfCurrent = document.getElementById("endOfCurrent");

  if (lastElementOfCurrent) observer.observe(lastElementOfCurrent);
};
